import { useStore } from '@nanostores/react';

import { $userStore } from './store';

export const useUserState = () => {
  return useStore($userStore);
};

export const useUser = () => {
  const state = useUserState();

  return state.user;
};

export const useIsAuthenticated = (): boolean => {
  const state = useUserState();

  return state.status === 'authenticated';
};
